<template>
  <section class="my-5">
    <h2>メンバーズクラブ会員登録申込</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li>申込入力</li>
        <li>内容確認</li>
        <li class="here">送信完了</li>                
      </ul>    
    </div>
    <div class="form-content">
      <h3>送信完了</h3>
      <p>ご登録のメールアドレスに「申込者情報の登録及び商品ご購入のお手続き」用のURLを送信いたしました。</p>
      <p class="my-5">メールに記載されているURLにアクセスし、申込者情報の登録及び商品ご購入のお手続きをお願いいたします。<br>URLは24時間を過ぎますと無効になりますので、ご注意ください。</p>
      <p class="exp fs-09">※メールが届かない場合、入力に誤りがある可能性があります。再度正しいメールアドレスにてご登録ください。<br>※ご利用のメールアドレスによっては手続き用のメールが「迷惑メールフォルダ」に入ってしまう場合があります。<br>迷惑メールフォルダに手続き用のメールが届いていないかご確認ください。<br>※ご使用のメールアプリの設定によっては弊社からのメールが受信いただけない場合があります。<br>迷惑メール設定のご確認、およびドメイン指定受信をご設定の方は「manavis-cosme.co.jp」からのメール受信の許可をお願いいたします。</p>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br>
      ◆お問い合わせ:0120-268-510<br>
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  mounted() {
    auth.removeNoLoginUid()
    window.scroll(0, 0);
  },
}
</script>
